import { Injectable } from '@angular/core';
import { ApiCommon } from '@shared/apis/common';
import { Observable } from 'rxjs';
import { ParamsBuilder } from '@shared/models/params-builder';

@Injectable({
  providedIn: 'root'
})
export class CompanyApi extends ApiCommon {

  getCompanies(pageEvent, q?: any, query?: any): Observable<any> {
    const builder = new ParamsBuilder();
    builder.pageEvent = pageEvent;
    builder.selectFields = ['name', 'description'];

    if (q) {
      builder.q = q;
    }

    if (query) {
      builder.query = query;
    }

    return this.apiServer.company.getCompanies(builder.build());
  }

  getCompany(bpNo): Observable<any> {
    return this.apiServer.company.getCompany(bpNo);
  }

  getCompanyCodes(): Observable<any> {
    return this.apiServer.company.getCompanyCodes();
  }
}
